export const languageFromCombitFlag = (value) => {
  if (value === true || value === "true") return "en";
  if (value === false || value === "false" || typeof value === "undefined") return "de";
  throw new Error(`isEnglishOffer must be "true" or "false"; received "${value}".`);
};

export const offerLanguageLabelFromCombitFlag = (value) =>
  languageFromCombitFlag(value).toUpperCase();
